<div class="bg-container">
    <nav>
        <a routerLink="/" class="logo-container">
            <img class="logo" *ngIf="settings.get('branding.logo_light')"
                [src]="settings.getBaseUrl(true) + settings.get('branding.logo_light')">
            <div class="text-logo" *ngIf="!settings.get('branding.logo_light')">{{settings.get('branding.site_name')}}
            </div>
        </a>
        <custom-menu position="homepage-navbar"></custom-menu>
        <div class="auth-buttons">
            <a class="auth-button" routerLink="/register" *ngIf="!settings.get('registration.disable')" mat-button
                trans>Register</a>
            <a class="auth-button" routerLink="/login" mat-stroked-button trans>Login</a>
        </div>
    </nav>
    <div class="content">
        <div class="title">
            {{settings.get('landingPage.title').substring(0, settings.get('landingPage.title').indexOf('!') + 1).trim()}}
            <div class="mo-fire">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   width="125px" height="189.864px" viewBox="0 0 125 189.864" enable-background="new 0 0 125 189.864" xml:space="preserve">
              <path class="flame-main" fill="#F36E21" d="M76.553,186.09c0,0-10.178-2.976-15.325-8.226s-9.278-16.82-9.278-16.82s-0.241-6.647-4.136-18.465
                  c0,0,3.357,4.969,5.103,9.938c0,0-5.305-21.086,1.712-30.418c7.017-9.333,0.571-35.654-2.25-37.534c0,0,13.07,5.64,19.875,47.54
                  c6.806,41.899,16.831,45.301,6.088,53.985"/>
              <path class="flame-main one" fill="#F6891F" d="M61.693,122.257c4.117-15.4,12.097-14.487-11.589-60.872c0,0,32.016,10.223,52.601,63.123
                  c20.585,52.899-19.848,61.045-19.643,61.582c0.206,0.537-19.401-0.269-14.835-18.532S57.576,137.656,61.693,122.257z"/>
              <path class="flame-main two" fill="#FFD04A" d="M81.657,79.192c0,0,11.549,24.845,3.626,40.02c-7.924,15.175-21.126,41.899-0.425,64.998
                  C84.858,184.21,125.705,150.905,81.657,79.192z"/>
              <path class="flame-main three" fill="#FDBA16" d="M99.92,101.754c0,0-23.208,47.027-12.043,80.072c0,0,32.741-16.073,20.108-45.79
                  C95.354,106.319,99.92,114.108,99.92,101.754z"/>
              <path class="flame-main four" fill="#F36E21" d="M103.143,105.917c0,0,8.927,30.753-1.043,46.868c-9.969,16.115-14.799,29.041-14.799,29.041
                  S134.387,164.603,103.143,105.917z"/>
              <path class="flame-main five" fill="#FDBA16" d="M62.049,104.171c0,0-15.645,67.588,10.529,77.655C98.753,191.894,69.033,130.761,62.049,104.171z"/>
              <path class="flame" fill="#F36E21" d="M101.011,112.926c0,0,8.973,10.519,4.556,16.543C99.37,129.735,106.752,117.406,101.011,112.926z"/>
              <path class="flame one" fill="#F36E21" d="M55.592,126.854c0,0-3.819,13.29,2.699,16.945C64.038,141.48,55.907,132.263,55.592,126.854z"/>
              <path class="flame two" fill="#F36E21" d="M54.918,104.595c0,0-3.959,6.109-1.24,8.949C56.93,113.256,52.228,107.329,54.918,104.595z"/>
              </svg>
            </div>
        </div>
        <div class="subtitle">{{settings.get('landingPage.subtitle')}}</div>
    </div>
    <div class="footer">
        <p>
            <a target="_blank" href="/blog">BLOG</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a routerLink="/about">ABOUT US</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a routerLink="/tos">TERMS</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a routerLink="/privacy">PRIVACY</a>
        </p>
    </div>
</div>
<section class="min-h-50 section--small section--small-reversed">
    <div class="container">
        <h1>Things you'll love ❤️</h1>
        <h3>
            <b>FIREFILE.CC</b> provides plenty of <b>FEATURES</b> and we'll add more constantly.
        </h3>
        <div class="row align-items-center justify-content-center">
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faShareAlt" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Share</h2>
                <p class="grey-text mb-md-0 mb-5">
                    Sharing you files is as easy as possible, and secured thanks to <b>end-to-end encryption</b>
                </p>
            </div>
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faSave" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Free Storage</h2>
                <p class="grey-text mb-md-0 mb-5">
                    <b>JOIN NOW</b> and get <b>50 GB</b> of <b>FREE</b> storage
                </p>
            </div>
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faCloudUploadAlt" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Up to 5 GB / file</h2>
                <p class="grey-text mb-md-0 mb-5">
                    Upload <b>single files</b> with a size up to <b>5 GB</b>
                </p>
            </div>
        </div>
    </div>
</section>
<section class="min-h-90 section--first">
    <div class="container">
        <h1>{{settings.get('landingPage.title')}}</h1>
        <h3>
            <b>FIREFILE.CC</b> provides an easy <b>AND</b> secured way to share your files with your friends, family and everyone else. All data uploaded is <b>encrypted</b> and thus cannot get viewn by anyone else.
            <br><br>
            <i>— <a class="link" routerLink="/register">Join today</a> and get <b>50 GB of FREE</b> storage!</i>
        </h3>
        <div class="row align-items-center justify-content-center">
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faUserLock" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Security</h2>
                <p class="grey-text mb-md-0 mb-5">
                    Everything you upload is <a class="link" href="/blog/2020/01/22/end-to-end-encryption/" target="_blank"><b>end-to-end encrypted</b></a> and only belongs to you!
                </p>
            </div>
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faShippingFast" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Unlimited Speed</h2>
                <p class="grey-text mb-md-0 mb-5">
                    Throttled download speed? Nope!
                </p>
            </div>
            <div class="col-7 col-sm-3">
                <fa-icon [icon]="faDollarSign" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">FREE</h2>
                <p class="grey-text mb-md-0 mb-5">
                    Get <b>50 GB</b> of free storage!
                </p>
            </div>
        </div>
    </div>
</section>
<section class="min-h-50 section--small">
    <div class="container">
        <h1>Join <b>NOW</b> and get 50 GB of <b>FREE</b> storage</h1>
        <br><br>
        <a class="auth-button" routerLink="/register" *ngIf="!settings.get('registration.disable')" mat-raised-button
                trans>Register NOW</a>
    </div>
</section>
<!--<section class="min-h-50 section--small section--small-reversed">
    <div class="container">
        <h1>Statistics</h1>
        <h3></h3>
        <div class="row align-items-center justify-content-center">
            <div class="col-7 col-sm-4">
                <fa-icon [icon]="faDownload" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Total Downloads</h2>
                <p class="grey-text mb-md-0 mb-5 counter-text" #totalDownloads></p>
            </div>
            <div class="col-7 col-sm-1">
            </div>
            <div class="col-7 col-sm-4">
                <fa-icon [icon]="faTrafficLight" size="3x"></fa-icon>
                <h2 class="font-weight-bold my-4">Total Traffic</h2>
                <p class="grey-text mb-md-0 mb-5 counter-text" #totalTraffic></p>
            </div>
        </div>
    </div>
</section>-->
